import { render, staticRenderFns } from "./Dotmenu.vue?vue&type=template&id=75e39810&scoped=true&"
import script from "./Dotmenu.vue?vue&type=script&lang=js&"
export * from "./Dotmenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75e39810",
  null
  
)

export default component.exports